import type { CategoryFilterInput } from "@zaprooecommerce/magento-types";
import type {
  CustomQuery,
  MethodOptions,
} from "@zaprooecommerce/magento-sdk/lib/types";
import type { CategorySearchResponse } from "@zaprooecommerce/magento-sdk/lib/methods/categorySearch";
import { merge } from "lodash-es";
import type { CategoryShort } from "~/types";

export function useCategorySearch() {
  const { categorySearch } = useMagentoSdk();

  async function searchCategory<T extends CategoryShort = CategoryShort>(
    filters: CategoryFilterInput,
    options?: MethodOptions<CustomQuery<"categorySearch">>,
  ): Promise<T[]> {
    const categorySearchResponse: CategorySearchResponse = await categorySearch(
      { filters },
      merge(
        {
          customQuery: {
            categorySearch: "categorySearch",
          },
        },
        options || {},
      ),
    );
    const categories: any[] = categorySearchResponse.data!.categoryList || [];
    return (categories as T[]) || [];
  }

  return {
    searchCategory,
  };
}
